import {
  GET_NEWS_SUCCESS,
  NOTIFY_SUCCESS,
  GET_NEWS_FAILURE,
} from './action-types'
import { notify } from './notification-actions'
import { request } from './auth-actions'
import { genericError, silentError } from './action-utils'
import { getText } from '../../internal/TextLabels'

import newsServiceApi from '../../api/news-service-api'
import { createNewsRequest } from '../../api/request-builder/news-service-request-builder'
//* ****************
// Actions
//* ****************

const getNewsSuccess = response => ({
  response,
  type: GET_NEWS_SUCCESS,
})

const getNewsFailure = error => ({
  error,
  type: GET_NEWS_FAILURE,
})

export const getUserNews = () => dispatch => {
  return dispatch(request(newsServiceApi.getUserArticles, null))
    .then(data => {
      dispatch(getNewsSuccess(data))
    })
    .catch(error => {
      silentError(error)
      dispatch(getNewsFailure(error))
      throw error
    })
}

export const markAsRead = articleId => dispatch => {
  return dispatch(
    request(newsServiceApi.articleAcknowledgement, articleId),
  ).catch(error => {
    genericError(error)
    throw error
  })
}

export const markSeveralAsRead = articleList => dispatch => {
  if (articleList) {
    articleList.forEach(article => {
      if (!article.acknowledged) {
        dispatch(markAsRead(article.id))
      }
    })
  }
}

export const getFilteredAdminNews = (page, filter) => dispatch => {
  return dispatch(
    request(newsServiceApi.getFilteredAdminArticles(filter, page)),
  ).catch(error => {
    genericError(error)
    throw error
  })
}

export const saveNewsArticle = newsEntry => dispatch => {
  return dispatch(
    request(newsServiceApi.saveArticle, createNewsRequest(newsEntry)),
  )
    .then(() => {
      notify(NOTIFY_SUCCESS, getText('news.entry.created'))
      dispatch(getUserNews())
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const deleteNewsArticle = articleId => dispatch => {
  return dispatch(request(newsServiceApi.deleteArticle, articleId))
    .then(() => {
      notify(NOTIFY_SUCCESS, getText('news.entry.deleted'))
      dispatch(getUserNews())
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}
